var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5928 7.15598C12.5928 6.88574 12.3737 6.66666 12.1035 6.66666C11.8332 6.66666 11.6142 6.88574 11.6142 7.15598V11.511H7.25946C6.98921 11.511 6.77014 11.7301 6.77014 12.0003C6.77014 12.2706 6.98921 12.4896 7.25946 12.4896L11.6142 12.4896L11.6142 16.844C11.6142 17.1143 11.8332 17.3333 12.1035 17.3333C12.3737 17.3333 12.5928 17.1143 12.5928 16.844V12.4896L16.9475 12.4896C17.2177 12.4896 17.4368 12.2706 17.4368 12.0003C17.4368 11.7301 17.2177 11.511 16.9475 11.511L12.5928 11.511L12.5928 7.15598Z",
    fill: "#FF6319"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#FF6319"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.d5f1ecdd6f8ca2abd7579f9541790224.svg";
export { ForwardRef as ReactComponent };